import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito diagnóstico médico para seguir el sistema?',
    a: 'No. Es para estreñimiento funcional (cuando los estudios dan "bien" pero seguís igual). Ante síntomas graves, consultá siempre a un médico.'
  }, {
    q: '¿Tengo que comprar productos importados o caros?',
    a: 'No. Todo se compra en ferias, farmacias o dietéticas de Argentina. El sistema está adaptado a marcas y precios locales.'
  }, {
    q: '¿Es compatible con medicamentos que tomo?',
    a: 'Sí, es nutricional. Solo explicamos cómo separar el magnesio de la medicación tiroidea o antibióticos. No altera lo recetado por tu médico.'
  }, {
    q: '¿El producto es 100% digital?',
    a: 'Sí. Recibís los PDFs por email al instante. Podés leerlos en cualquier dispositivo o imprimirlos. El acceso es tuyo de por vida.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. Tenés 21 días para probarlo. Si no te gusta, te devolvemos el 100% de tu dinero sin dar explicaciones.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 bg-brand-black" data-id="element-93">
      <div className="container mx-auto px-4" data-id="element-94">
        <div className="max-w-3xl mx-auto" data-id="element-95">
          <div className="text-center mb-12" data-id="element-96">
            <h2 className="text-3xl md:text-4xl font-bold font-[Poppins,_sans-serif]" data-id="element-97">
              ❓ PREGUNTAS FRECUENTES
            </h2>
          </div>

          <div className="space-y-4" data-id="element-98">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="border border-gray-800 rounded-xl overflow-hidden bg-brand-dark" data-id="element-99">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-100">
                  <span className="font-bold text-lg text-white pr-8" data-id="element-101">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-light shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-102" />
                </button>
                <AnimatePresence data-id="element-103">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-104">
                      <div className="p-6 pt-0 text-gray-300 leading-relaxed border-t border-gray-800/50 mt-2" data-id="element-105">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}